import {
    createSlice
} from "@reduxjs/toolkit";
import {
    addWorks,
    deleteWorks,
    getWorks,
    works
} from "./thunk";
export const initialState = {
    data:[],
    error: "", // for error message
    loading: false,
};

const workSlice = createSlice({
    name: "works",
    initialState,
    // reducers: {
    //     apiError(state, action) {
    //         state.error = action.payload.data;
    //         state.loading = true;
    //         state.isUserLogout = false;
    //         state.errorMsg = true;
    //     },
    //     updateBusinessInfo(state, action) {
    //         if (action.payload.business_type) {
    //             state.works.business_type = action.payload.business_type
    //         }
    //         if (action.payload.gst_in) {
    //             state.works.gst_in = action.payload.gst_in
    //         }
    //         //   state.businessInfo = action.payload
    //         state.loading = false;
    //         state.errorMsg = false;
    //     },

    // },
    extraReducers: (builder) => {
        builder
            .addCase(getWorks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getWorks.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getWorks.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            })
            .addCase(addWorks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addWorks.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(addWorks.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : action.error.message;
                state.loading = false;
            })
            .addCase(deleteWorks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteWorks.fulfilled, (state, action) => {
                state.data.push(action.payload);
                state.loading = false;
            })
            .addCase(deleteWorks.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : action.error.message;
                state.loading = false;
            })
    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default workSlice.reducer;